var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 95 95",
    enableBackground: "new 0 0 95 95",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.209,81.737V52.549c11.432-1.04,20.438-12.403,20.438-26.277c0-0.162-0.008-0.322-0.01-0.481  c-0.016-0.453-0.058-1.221-0.162-2.255c-0.107-1.072-0.283-2.431-0.57-4.038c-0.722-4.04-2.148-8.148-4.959-12.959H31.054  c-2.81,4.811-4.237,8.919-4.959,12.959c-0.287,1.607-0.462,2.966-0.569,4.038c-0.104,1.034-0.146,1.802-0.162,2.255  c-0.002,0.159-0.01,0.319-0.01,0.481c0,13.874,9.006,25.237,20.437,26.277v29.188c-9.161,0.161-16.331,1.602-16.331,3.354  c0,1.861,8.077,3.37,18.041,3.37c9.963,0,18.04-1.509,18.04-3.37C65.54,83.339,58.371,81.898,49.209,81.737z M47.5,49.746  c-0.577,0-1.146-0.035-1.71-0.094c-9.896-1.031-17.661-10.917-17.661-22.966c0-0.142,0.006-0.281,0.009-0.421  c0.017-0.5,0.069-1.436,0.224-2.73c0.096-0.795,0.229-1.724,0.416-2.773c0.631-3.534,1.88-7.127,4.337-11.335h28.771  c2.457,4.208,3.706,7.801,4.337,11.335c0.188,1.05,0.321,1.979,0.416,2.773H31.742c-0.141,1.295-0.189,2.23-0.205,2.73  c-0.002,0.14-0.008,0.279-0.008,0.421c0,12.049,7.108,21.935,16.168,22.966c0.238,0.026,0.48,0.048,0.723,0.064  C48.114,49.735,47.809,49.746,47.5,49.746z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWine);
export default __webpack_public_path__ + "static/media/WINE.6f1035b534d7ae7795c9e0377ea2dd78.svg";
export { ForwardRef as ReactComponent };